import * as React from 'react';
import AdminPageEmptyState from '../admin_page_empty_state';
import { MemberRoles as Roles, } from '../../types/members';
import Table from '@doordash/component-table';
import { Text, InlineChildren, Icon } from '@doordash/design-language';
import Tag from '@doordash/component-tag';
import { tableStyle } from '../AdminPage/AdminPageStyles';
import { EmployeeListActionMenu } from './EmployeeListActionMenu';
export var AdminMembersList = React.memo(function (_a) {
    var members = _a.members, page = _a.page, onPageChange = _a.onPageChange, isLoading = _a.isLoading, onRemoveMemberClick = _a.onRemoveMemberClick, totalPages = _a.totalPages, currentTeamMember = _a.currentTeamMember, onToggleAdminAccess = _a.onToggleAdminAccess, handleResendIndividualInvites = _a.handleResendIndividualInvites, isSearchMode = _a.isSearchMode;
    var rows = React.useMemo(function () {
        return members.map(function (member) { return ({
            id: member.id,
            email: member.email,
            status: member.status === 'ACTIVE' ? 'Active' : 'Pending',
            roles: member.roles,
            member: member,
        }); });
    }, [members]);
    var columns = React.useMemo(function () { return [
        {
            name: 'EMAIL',
            accessor: 'email',
            Cell: function (props) {
                var _a = props.row.original, roles = _a.roles, email = _a.email;
                var isAdmin = roles && roles.includes(Roles.ADMIN);
                return (React.createElement(InlineChildren, null,
                    React.createElement(Text, { color: Text.Colors.TextSecondary }, email),
                    isAdmin && React.createElement(Tag, { text: 'Admin' })));
            },
        },
        {
            name: 'STATUS',
            accessor: 'status',
        },
        {
            name: 'menu',
            accessor: 'id',
            Cell: function (props) {
                var member = props.row.original.member;
                return (React.createElement(EmployeeListActionMenu, { member: member, currentTeamMember: currentTeamMember, onRemoveMemberClick: onRemoveMemberClick, onToggleAdminAccess: onToggleAdminAccess, handleResendIndividualInvites: handleResendIndividualInvites }));
            },
        },
    ]; }, [
        onToggleAdminAccess,
        onRemoveMemberClick,
        currentTeamMember,
        handleResendIndividualInvites,
    ]);
    if (!isLoading && totalPages === 0) {
        return (React.createElement(AdminPageEmptyState, { icon: React.createElement(Icon, { type: Icon.Types.PersonFindFill, size: Icon.Sizes.Large }), title: isSearchMode
                ? 'No members found matching your search'
                : 'No Members', subtitle: isSearchMode ? '' : 'Start by adding members to the account' }));
    }
    return (React.createElement(Table, { showDataLoading: isLoading, currentPage: page, manualPagination: true, data: rows, columns: columns, hiddenHeaders: ['id'], isSortable: false, rowsPerPage: members.length, numPages: totalPages, onPageChange: onPageChange, bodyTextProps: {
            size: Text.Sizes.S16,
            color: Text.Colors.TextSecondary,
            weight: Text.Weights.Medium,
        }, headerTextProps: {
            size: Text.Sizes.S12,
            color: Text.Colors.TextSecondary,
            weight: Text.Weights.Medium,
        }, tableStyles: tableStyle }));
});
export default AdminMembersList;
